var SHOPIFY_ADMIN_TOKEN = "DF4BFFC6BFC449B4992A19168F866180";
var API = "https://webapi.playswing.net";
var FACEBOOK_PIXEL_ID = "";
var TIKTOK_PIXEL_ID = "";

(function () {
    "use strict";

    const checkoutConfig = {
        PRICE_SELECTORS: [
            "[data-price]",
            ".price",
            ".money",
            ".current-price",
            ".product-price",
            ".price--current .price-item--regular",
            ".price .price-item--regular",
            ".product__price .price-item--regular",
            ".price--current",
            ".price-current",
            ".price__current",
            'span[class*="price"]',
            'div[class*="price"]',
            '[class*="price"]',
        ],
        TITLE_SELECTORS: [
            "h1[data-product-title]",
            "[data-product-title]",
            "h1",
            ".product__title",
            ".product-title",
            ".product_title",
            ".product-single__title",
            ".product-meta h1",
            ".product-info h1",
            ".product-details h1",
            ".product-form h1",
        ],
        FORM_SELECTORS: [
            'form[action*="/cart/add"]',
            ".product-form",
            "[data-product-id]",
            "form",
        ],
        VARIANT_SELECTORS: [
            '[name="id"]',
            'select[name="id"] option:checked',
            'input[name="id"]:checked',
            "[data-variant-id]",
            ".product-variant-id",
        ],
        QUANTITY_SELECTORS: [
            '[name="quantity"]',
            ".quantity-input input",
            'input[type="number"]',
            "[data-quantity]",
        ],
        IMAGE_SELECTORS: [
            "img[data-product-image]",
            'img[alt*="product"]',
            'img[src*="product"]',
            ".product__media--featured img",
            ".product__media.is-active img",
            ".product__media img:first-child",
            ".product-media img:first-child",
            ".product-single__media img",
            ".product-image-main img",
            ".product-photo-main img",
            ".featured-image img",
            ".product-image img",
            ".product-photo img",
            ".product-gallery img:first-child",
            ".product img:first-child",
            ".main-product-image img",
            ".product-single__photo img",
            ".product__photo img",
            ".product-photos img:first-child",
            ".slideshow img:first-child",
            ".product-slideshow img:first-child",
            ".hero img",
            "main img:first-child",
        ],
        VARIANT_TITLE_SELECTORS: [
            'select[name*="id"] option:checked',
            'input[name*="option"]:checked',
            ".product-form__input:checked + label",
            ".variant-input:checked + label",
            "[data-option-value]",
        ],
        DEBUG: true,
        API_ENDPOINTS: {},
    };
    checkoutConfig.API_ENDPOINTS.CART = "/cart.js";
    checkoutConfig.API_ENDPOINTS.PRODUCT = (b) => "/" + b + ".js";
    const CONFIG = checkoutConfig;
    const utils = {
        getUrlParameter: function (f) {
            try {
                const a = new URLSearchParams(window.location.search).get(f);
                if (a) {
                    return a;
                }
                const b = decodeURIComponent(window.location.href);
                const c = b.match(new RegExp("[?&]" + f + "=([^&#]+)"));
                const d = c ? c[1] : null;
                return d;
            } catch (b) {
                return null;
            }
        },
        findElement: function (c, e = document) {
            for (const b of c) {
                const c = e.querySelector(b);
                if (c) {
                    if (CONFIG.DEBUG);
                    return c;
                }
            }
            if (CONFIG.DEBUG);
            return null;
        },
        cleanPrice: function (d) {
            if (!d) {
                return "0";
            }
            const a = /^\D*\d+,\d{2}\D*$/.test(d);
            if (a) {
                const a = d.replace(",", ".");
                const b = a.replace(/[^\d.]/g, "");
                return b || "0";
            } else {
                const a = d.replace(/[^\d.]/g, "");
                return a || "0";
            }
        },
        getProductHandle: function () {
            const c = window.location.pathname;
            const a = c.match(/\/products\/([^\/]+)/);
            if (a) {
                return a[1];
            } else {
                return null;
            }
        },
        getProductTitle: function () {
            const titleElement = this.findElement(CONFIG.TITLE_SELECTORS, document);
            return titleElement ? titleElement.textContent.trim() : "";
        },
        log: function (c, a = null) {
            if (CONFIG.DEBUG);
        },
    };
    const { protocol, hostname } = window.location;
    const parts = hostname.replace(/^www\./, "").split(".");
    const mainDomain = parts.slice(-2).join(".");
    const checkoutBaseUrl = `${protocol}//pay.${mainDomain}/checkouts`;

    const CHECKOUT_BUTTON_SELECTORS = [
        ".btn--checkout",
        ".btn--cart-sidebar-checkout",
        ".checkout-button",
        ".cart__checkout",
        ".cart__checkout-button",
        ".cart-checkout",
        '[href*="/checkout"]',
        'button[name="checkout"]',
        'input[name="checkout"]',
        ".shopify-payment-button__button",
        ".dynamic-checkout__content button",
        ".payment-button",
        ".checkout-btn",
        'button[name="goto_pp"]',
        'button[name="goto_gc"]',
        ".shopify-payment-button__more-options",
        "#more-payment-options-link",
        "more-payment-options-link",
        "[data-shopify-buttoncontainer]",
        ".shopify-payment-button",
        ".dynamic-checkout__content",
        'iframe[name*="paypal"]',
        'iframe[title*="PayPal"]',
        ".paypal-button-container",
        ".paypal-buttons",
        ".button-checkout",
    ];
    const ADD_TO_CART_SELECTORS = [
        'button[name="add"]',
        'input[name="add"]',
        ".product-form__cart-submit",
        ".btn.product-form__cart-submit",
        ".product__add-to-cart",
        ".add-to-cart",
        '.product-form button[type="submit"]',
    ];
    const isAddToCartButton = (c) =>
        ADD_TO_CART_SELECTORS.some((a) => c.matches(a));
    const isCheckoutButton = (c) =>
        CHECKOUT_BUTTON_SELECTORS.some((a) => c.matches(a));
    const isCartCheckoutContext = (element) => {
        if (window.location.pathname.includes("/cart")) {
            return true;
        }
        const fromContext = Boolean(
            element.closest(
                ".cart, .cart-drawer, .cart-page, .cart-sidebar, .drawer__content, [data-cart]",
            ),
        );
        const cartNotification = document.querySelector("#cart-notification");
        const isNotificationActive =
            cartNotification?.classList.contains("active") || false;
        const hasCartSidebarShow =
            document.body?.classList?.contains("cart-sidebar-show") || false;
        return fromContext || isNotificationActive || hasCartSidebarShow;
    };
    const hasCollectedProducts = (payload) =>
        payload && Array.isArray(payload.products) && payload.products.length > 0;
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    async function collectCheckoutPayload(element) {
        const shouldReadCart = isCartCheckoutContext(element);
        let payload = shouldReadCart
            ? await collectCart()
            : await collectProductWithVariantFallback(element);

        if (hasCollectedProducts(payload)) {
            return payload;
        }

        await delay(600);
        payload = shouldReadCart
            ? await collectCart()
            : await collectProductWithVariantFallback(element);

        if (hasCollectedProducts(payload)) {
            return payload;
        }

        return await collectProductWithVariantFallback(element);
    }

    function getCheckoutLoadingTarget(element) {
        return (
            element.closest(
                'button, input[type="submit"], input[type="button"], a, .shopify-payment-button__button, .paypal-button-container, .paypal-buttons, [data-shopify-buttoncontainer]',
            ) || element
        );
    }

    function setCheckoutButtonLoading(element) {
        const target = getCheckoutLoadingTarget(element);
        if (!target || target.dataset.checkoutLoading === "true") {
            return () => { };
        }

        target.dataset.checkoutLoading = "true";
        target.dataset.checkoutOriginalMinWidth = target.style.minWidth || "";
        target.style.minWidth = target.offsetWidth
            ? `${target.offsetWidth}px`
            : target.style.minWidth;
        target.setAttribute("aria-busy", "true");
        target.classList.add("custom-checkout-loading");

        const canDisable =
            target.tagName === "BUTTON" ||
            target.tagName === "INPUT" ||
            target.getAttribute("role") === "button";
        const wasDisabled = target.disabled;
        if (canDisable) {
            target.disabled = true;
        }

        const originalHtml = target.innerHTML;
        const originalValue = target.value;
        const isInput = target.tagName === "INPUT";
        const canReplaceContent =
            target.tagName === "BUTTON" ||
            target.tagName === "A" ||
            target.getAttribute("role") === "button";

        if (isInput) {
            target.value = "Loading...";
        } else if (canReplaceContent) {
            target.innerHTML =
                '<span class="custom-checkout-loading-spinner" aria-hidden="true"></span><span>Loading...</span>';
        } else {
            target.classList.add("custom-checkout-loading-overlay");
        }

        return () => {
            delete target.dataset.checkoutLoading;
            target.style.minWidth = target.dataset.checkoutOriginalMinWidth || "";
            delete target.dataset.checkoutOriginalMinWidth;
            target.removeAttribute("aria-busy");
            target.classList.remove("custom-checkout-loading");
            target.classList.remove("custom-checkout-loading-overlay");
            if (canDisable) {
                target.disabled = wasDisabled;
            }
            if (isInput) {
                target.value = originalValue;
            } else if (canReplaceContent) {
                target.innerHTML = originalHtml;
            }
        };
    }

    async function handleCheckoutClick(event, element) {
        event.preventDefault();
        event.stopPropagation();

        const loadingTarget = getCheckoutLoadingTarget(element);
        if (loadingTarget?.dataset.checkoutLoading === "true") {
            return;
        }

        const restoreLoading = setCheckoutButtonLoading(loadingTarget);
        try {
            const payload = await collectCheckoutPayload(element);
            await redirectToHostedCheckout(payload);
            setTimeout(() => {
                if (document.visibilityState !== "hidden") {
                    restoreLoading();
                }
            }, 3000);
        } catch (error) {
            restoreLoading();
            console.error("Checkout redirect failed:", error);
        }
    }
    // Product and cart collection
    async function fetchCurrentProductJson() {
        try {
            const d = window.location.pathname;
            if (d.includes("/products/")) {
                const a = d.split("/products/")[1].split("?")[0].split("/")[0];
                const b = await fetch("/products/" + a + ".js");
                if (b.ok) {
                    return await b.json();
                } else {
                    return null;
                }
            }
        } catch (b) { }
        return null;
    }

    function normalizeOptionValue(value) {
        return String(value || "")
            .trim()
            .replace(/\s+/g, " ")
            .toLowerCase();
    }

    function pushSelectedOption(values, value) {
        const normalized = normalizeOptionValue(value);
        if (normalized && !values.includes(normalized)) {
            values.push(normalized);
        }
    }

    function getSelectedOptionValues(form, productContainer) {
        const values = [];
        const scopes = [form, productContainer, document].filter(Boolean);

        for (const scope of scopes) {
            scope
                .querySelectorAll(
                    'select[name^="options["], select[name^="option"], select[data-option-position]',
                )
                .forEach((select) => {
                    const selectedOption = select.options?.[select.selectedIndex];
                    pushSelectedOption(values, selectedOption?.value || select.value);
                });

            scope
                .querySelectorAll(
                    'input[type="radio"]:checked, input[type="checkbox"]:checked',
                )
                .forEach((input) => {
                    if (input.name === "id" || input.name === "quantity") {
                        return;
                    }
                    pushSelectedOption(values, input.value);
                });

            scope
                .querySelectorAll(
                    '[aria-pressed="true"], [aria-selected="true"], .selected, .is-selected, [data-selected="true"]',
                )
                .forEach((element) => {
                    pushSelectedOption(
                        values,
                        element.dataset.optionValue ||
                        element.dataset.value ||
                        element.getAttribute("value") ||
                        element.textContent,
                    );
                });

            if (values.length > 0) {
                break;
            }
        }

        return values;
    }

    function findVariantBySelectedOptions(productJson, selectedOptions) {
        if (!productJson?.variants?.length || !selectedOptions.length) {
            return null;
        }

        return (
            productJson.variants.find((variant) => {
                const variantOptions = [
                    variant.option1,
                    variant.option2,
                    variant.option3,
                    ...(variant.options || []),
                ].map(normalizeOptionValue);

                return selectedOptions.every((optionValue) =>
                    variantOptions.includes(optionValue),
                );
            }) || null
        );
    }

    function getSelectedVariantId(clickedElement, form, productContainer) {
        const variantFromUrl = new URLSearchParams(window.location.search).get(
            "variant",
        );
        if (variantFromUrl) {
            return variantFromUrl;
        }

        const selectedVariantElement =
            clickedElement.closest("[data-variant-id]") ||
            form?.querySelector(
                '[data-variant-id][aria-pressed="true"], [data-variant-id][aria-selected="true"], [data-variant-id].selected, [data-variant-id].is-selected, [data-variant-id][data-selected="true"]',
            ) ||
            productContainer?.querySelector(
                '[data-variant-id][aria-pressed="true"], [data-variant-id][aria-selected="true"], [data-variant-id].selected, [data-variant-id].is-selected, [data-variant-id][data-selected="true"]',
            );

        if (selectedVariantElement?.dataset.variantId) {
            return selectedVariantElement.dataset.variantId;
        }

        if (form) {
            const formDataVariantId = new FormData(form).get("id");
            if (formDataVariantId) {
                return formDataVariantId;
            }

            const variantInput =
                form.querySelector('input[name="id"]') ||
                form.querySelector('select[name="id"]') ||
                form.querySelector('[name="id"]');
            if (variantInput) {
                return variantInput.value || variantInput.dataset.variantId;
            }
        }

        return (
            clickedElement.dataset.variantId ||
            productContainer?.dataset.variantId ||
            null
        );
    }

    async function collectProductFromElement(c) {
        const a = {
            type: "single",
            products: [],
        };
        let d = c.closest(
            "product-card, product-form-component, .product-item, .product-card, .grid__item, .product, [data-product], [data-product-id], .card, .card-wrapper, li, article",
        );
        if (d && d.tagName === "PRODUCT-FORM-COMPONENT") {
            const c = d.closest(
                "product-card, .product-item, .product-card, .grid__item, .product, [data-product], [data-product-id]",
            );
            if (c && c !== d) {
                const a = d;
                d = c;
                if (!d.dataset.productUrl && a.dataset.productUrl) {
                    d.dataset.productUrl = a.dataset.productUrl;
                }
            }
        }
        if (!d) {
            const a = c.closest("quick-add-component");
            if (a) {
                d = a.closest(
                    "product-card, product-form-component, .product-item, .product-card, .grid__item, .product, [data-product], [data-product-id]",
                );
            }
        }
        if (d) {
            const a = d.querySelectorAll('a[href*="/products/"]');
            if (a.length > 1) {
                let e = c.parentElement;
                while (e && e !== d) {
                    const b = e.querySelectorAll('a[href*="/products/"]');
                    if (b.length === 1) {
                        d = e;
                        break;
                    }
                    e = e.parentElement;
                }
            }
        }
        let o = null;
        if (d) {
            o =
                d.querySelector('form[action*="/cart/add"]') || d.querySelector("form");
        }
        if (!o) {
            o =
                c.closest("form") ||
                c.form ||
                utils.findElement(CONFIG.FORM_SELECTORS, c.closest("form") || document);
        }
        let p = getSelectedVariantId(c, o, d);
        let q = null;
        if (d) {
            if (d.dataset.productUrl) {
                const b = d.dataset.productUrl.match(/\/products\/([^?#/]+)/);
                if (b) {
                    q = b[1];
                }
            }
            if (!q) {
                const c = d.querySelectorAll('a[href*="/products/"]');
                for (const d of c) {
                    const b = d.href.match(/\/products\/([^?#/]+)/);
                    if (b) {
                        q = b[1];
                        break;
                    }
                }
            }
        }
        if (!q && window.location.pathname.includes("/products/")) {
            const b = window.location.pathname.match(/\/products\/([^?#/]+)/);
            if (b) {
                q = b[1];
            }
        }
        let b = 1;
        if (o) {
            const c = o.querySelector('input[name="quantity"]');
            if (c) {
                b = c.value || 1;
            } else {
                const quantityInput = document.querySelector('input[name="quantity"]');
                if (quantityInput) {
                    b = quantityInput.value || 1;
                } else {
                    b = document.querySelector(".cc-select__btn").textContent.trim() || 1;
                }
            }
        } else if (d) {
            const c = d.querySelector('input[name="quantity"]');
            b = c?.value || 1;
        }
        let r = "";
        let s = "0";
        let t = "";
        const selectedOptions = getSelectedOptionValues(o, d);
        if (q) {
            try {
                const c = "/products/" + q + ".js";
                const d = await fetch(c);
                if (d.ok) {
                    const c = await d.json();
                    r = c.title || "";
                    const selectedVariant = findVariantBySelectedOptions(
                        c,
                        selectedOptions,
                    );
                    if (selectedVariant) {
                        p = selectedVariant.id;
                        s = (selectedVariant.price / 100).toString();
                        if (selectedVariant.featured_image) {
                            t = selectedVariant.featured_image.src;
                        } else if (c.images && c.images.length > 0) {
                            t = c.images[0];
                        }
                    } else if (p) {
                        const a = c.variants?.find((b) => b.id.toString() === p.toString());
                        if (a) {
                            s = (a.price / 100).toString();
                            if (a.featured_image) {
                                t = a.featured_image.src;
                            } else if (c.images && c.images.length > 0) {
                                t = c.images[0];
                            }
                        }
                    } else if (c.variants && c.variants.length > 0) {
                        p = c.variants[0].id;
                        s = (c.variants[0].price / 100).toString();
                        if (c.variants[0].featured_image) {
                            t = c.variants[0].featured_image.src;
                        } else if (c.images && c.images.length > 0) {
                            t = c.images[0];
                        }
                    }
                }
            } catch (b) { }
        }
        if (!r && window.location.pathname.includes("/products/")) {
            try {
                const c = window.location.pathname + ".js";
                const d = await fetch(c);
                if (d.ok) {
                    const c = await d.json();
                    r = c.title || "";
                    const selectedVariant = findVariantBySelectedOptions(
                        c,
                        selectedOptions,
                    );
                    if (selectedVariant) {
                        p = selectedVariant.id;
                        s = (selectedVariant.price / 100).toString();
                        if (selectedVariant.featured_image) {
                            t = selectedVariant.featured_image.src;
                        } else if (c.images && c.images.length > 0) {
                            t = c.images[0];
                        }
                    } else if (p) {
                        const a = c.variants?.find((b) => b.id.toString() === p.toString());
                        if (a) {
                            s = (a.price / 100).toString();
                            if (a.featured_image) {
                                t = a.featured_image.src;
                            } else if (c.images && c.images.length > 0) {
                                t = c.images[0];
                            }
                        }
                    } else if (c.variants && c.variants.length > 0) {
                        p = c.variants[0].id;
                        s = (c.variants[0].price / 100).toString();
                        if (c.variants[0].featured_image) {
                            t = c.variants[0].featured_image.src;
                        } else if (c.images && c.images.length > 0) {
                            t = c.images[0];
                        }
                    }
                }
            } catch (b) { }
        }
        if (!r) {
            if (d) {
                const b = d.querySelector(
                    '.product-title, .product__title, .card__heading, h2, h3, a[href*="/products/"]',
                );
                if (b) {
                    r = b.textContent.trim();
                }
            }
            if (!r && window.location.pathname.includes("/products/")) {
                r = utils.getProductTitle();
            }
        }
        if (!s || s === "0") {
            let c = null;
            if (d) {
                c = d.querySelector(
                    ".price, .product-price, .price__regular, [data-price], .money",
                );
            }
            if (!c && window.location.pathname.includes("/products/")) {
                c = utils.findElement(CONFIG.PRICE_SELECTORS, document);
            }
            const e = c?.textContent?.trim() || c?.dataset.price || "0";
            if (e) {
                const b = utils.cleanPrice(e);
                if (b !== "0") {
                    s = b;
                }
            }
        }
        if (!t) {
            if (d) {
                const c = d.querySelector("img");
                if (c) {
                    let a = c.src || c.dataset.src || c.dataset.original;
                    if (a) {
                        a = a.split("?")[0];
                        if (!a.startsWith("http")) {
                            a = a.startsWith("//")
                                ? "https:" + a
                                : a.startsWith("/")
                                    ? window.location.origin + a
                                    : a;
                        }
                        if (!a.includes("placeholder") && !a.includes("no-image")) {
                            t = a;
                        }
                    }
                }
            }
            if (!t && window.location.pathname.includes("/products/")) {
                const c = [
                    ".product__media--featured img",
                    ".product__media.is-active img",
                    ".product__media img:first-child",
                    ".product-media img:first-child",
                    ".product-single__media img",
                    ".product-image-main img",
                    ".product-photo-main img",
                    ".featured-image img",
                    ".product-image img",
                    ".product-photo img",
                    ".product-gallery img:first-child",
                    ".product img:first-child",
                    "img[data-product-image]",
                    ".main-product-image img",
                    ".product-single__photo img",
                    ".product__photo img",
                    ".product-photos img:first-child",
                    ".slideshow img:first-child",
                    ".product-slideshow img:first-child",
                    ".hero img",
                    "main img:first-child",
                    'img[alt*="product"]',
                    'img[src*="product"]',
                ];
                for (const d of c) {
                    const c = document.querySelector(d);
                    if (c) {
                        let a =
                            c.src ||
                            c.dataset.src ||
                            c.dataset.original ||
                            c.getAttribute("data-srcset")?.split(",")[0]?.split(" ")[0] ||
                            c.srcset?.split(",")[0]?.split(" ")[0] ||
                            "";
                        if (a) {
                            a = a.split("?")[0];
                            if (!a.startsWith("http")) {
                                a = a.startsWith("//")
                                    ? "https:" + a
                                    : a.startsWith("/")
                                        ? window.location.origin + a
                                        : a;
                            }
                            if (
                                !a.includes("placeholder") &&
                                !a.includes("no-image") &&
                                !a.includes("default") &&
                                a.length > 10
                            ) {
                                t = a;
                                break;
                            }
                        }
                    }
                }
            }
        }
        let u = "";
        if (o) {
            const c = [
                'select[name*="id"] option:checked',
                'input[name*="option"]:checked',
                ".product-form__input:checked + label",
                ".variant-input:checked + label",
            ];
            for (const d of c) {
                const b = o.querySelector(d) || document.querySelector(d);
                if (b) {
                    u += (u ? " / " : "") + b.textContent.trim();
                }
            }
        }
        const v = {
            id: p || Date.now().toString(),
            title: r,
            variant_title: u,
            quantity: parseInt(b) || 1,
            price: s,
            image: t,
        };
        a.products.push(v);
        return a;
    }
    async function collectCart() {
        try {
            const d = await fetch("/cart.js");
            const a = await d.json();
            const b = {
                type: "cart",
                products: a.items.map((b) => ({
                    id: b.variant_id,
                    title: b.product_title,
                    variant_title: b.variant_title,
                    quantity: b.quantity,
                    price: (b.price / 100).toFixed(2),
                    image: b.image,
                    line_price: (b.line_price / 100).toFixed(2),
                })),
                total: (a.total_price / 100).toFixed(2),
            };
            return b;
        } catch (b) {
            return {
                type: "cart",
                products: [],
                total: "0",
            };
        }
    }
    async function collectProductWithVariantFallback(f) {
        try {
            let e = await collectProductFromElement(f);
            let a =
                !e?.products?.[0]?.id ||
                e.products[0].id === "unknown" ||
                isNaN(e.products[0].id) ||
                parseInt(e.products[0].id) <= 0;
            if (a) {
                const a = await fetch("/cart.js");
                const g = a.ok
                    ? await a.json()
                    : {
                        items: [],
                    };
                const b =
                    f.closest('form[action*="/cart/add"]') ||
                    f.closest(".product-form") ||
                    document.querySelector('form[action*="/cart/add"]');
                if (b) {
                    const d = await fetch("/cart/add.js", {
                        method: "POST",
                        body: new FormData(b),
                    });
                    if (d.ok) {
                        const b = await d.json();
                        if (e?.products?.[0]) {
                            e.products[0].id = b.variant_id;
                        }
                        try {
                            const c = {
                                id: b.variant_id,
                                quantity: 0,
                            };
                            await fetch("/cart/change.js", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify(c),
                            });
                            if (g.items.length > 0) {
                                const c = {};
                                g.items.forEach((a) => (c[a.variant_id] = a.quantity));
                                const a = {
                                    updates: c,
                                };
                                await fetch("/cart/update.js", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify(a),
                                });
                            }
                        } catch (b) { }
                    }
                }
            }
            return e || (await collectProductFromElement(f));
        } catch (a) {
            return await collectProductFromElement(f);
        }
    }
    // Checkout button interception
    function hijackAcceleratedCheckoutButtons() {
        const d = document.querySelectorAll(
            ".shopify-payment-button__more-options, #more-payment-options-link, more-payment-options-link a",
        );
        d.forEach((d) => {
            if (d.dataset.hijacked) {
                return;
            }
            d.dataset.hijacked = "true";
            d.addEventListener(
                "click",
                async function (a) {
                    await handleCheckoutClick(a, d);
                },
                true,
            );
        });
        const a = document.querySelectorAll(
            ".paypal-button-container, .paypal-buttons, [data-shopify-buttoncontainer]",
        );
        a.forEach((e) => {
            if (e.dataset.hijacked) {
                return;
            }
            e.dataset.hijacked = "true";
            e.addEventListener(
                "click",
                async function (a) {
                    const b = a.target;
                    const c =
                        b.closest('iframe[name*="paypal"]') ||
                        b.closest('iframe[title*="PayPal"]') ||
                        e.querySelector('iframe[name*="paypal"]') ||
                        e.querySelector('iframe[title*="PayPal"]');
                    if (c || true) {
                        await handleCheckoutClick(a, e);
                    }
                },
                true,
            );
        });
        const b = document.querySelectorAll(
            'iframe[name*="paypal"], iframe[title*="PayPal"]',
        );
        b.forEach((d) => {
            if (d.dataset.hijacked) {
                return;
            }
            d.dataset.hijacked = "true";
            d.addEventListener(
                "click",
                async function (a) {
                    await handleCheckoutClick(a, d);
                },
                true,
            );
            d.addEventListener("load", () => addPaypalOverlay(d));
        });
    }
    function addPaypalOverlay(d) {
        if (d.parentNode.querySelector(".paypal-overlay")) {
            return;
        }
        const a = document.createElement("div");
        a.className = "paypal-overlay";
        a.style.cssText =
            "position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: transparent; z-index: 999; cursor: pointer;";
        const b = d.parentNode;
        if (getComputedStyle(b).position === "static") {
            b.style.position = "relative";
        }
        a.addEventListener("click", async function (a) {
            await handleCheckoutClick(a, d);
        });
        b.appendChild(a);
    }
    // Store metadata helpers
    async function getStoreCurrencyInfo() {
        try {
            const b = detectCurrencyFromPage();
            if (b) {
                return b;
            }
            try {
                const e = window.location.hostname;
                const a = {
                    "X-Shopify-Access-Token": SHOPIFY_ADMIN_TOKEN,
                    "Content-Type": "application/json",
                };
                const b = {
                    headers: a,
                };
                const f = await fetch(
                    "https://" + e + "/admin/api/2023-10/shop.json",
                    b,
                );
                if (f.ok) {
                    const d = await f.json();
                    const a = d.shop.currency || "USD";
                    const b = d.shop.money_format || "{{amount}}";
                    const c = {
                        currency: a,
                        money_format: b,
                    };
                    return c;
                }
            } catch (b) { }
            return {
                currency: "USD",
                money_format: "{{amount}}",
            };
        } catch (b) {
            return {
                currency: "USD",
                money_format: "{{amount}}",
            };
        }
    }
    function detectCurrencyFromPage() {
        try {
            const c = [
                ".price",
                ".product-price",
                ".price__regular",
                ".price__sale",
                ".money",
                '[class*="price"]',
                '[class*="money"]',
                ".product__price",
                ".product-price__regular",
                ".product-price__sale",
            ];
            for (const d of c) {
                const c = document.querySelectorAll(d);
                for (const d of c) {
                    const e = d.textContent || d.innerText;
                    if (e) {
                        const d = e.match(/\b([A-Z]{3})\b/);
                        if (d) {
                            const c = d[1];
                            if (isKnownCurrency(c)) {
                                const a = {
                                    currency: c,
                                    money_format: "{{amount}}",
                                };
                                return a;
                            }
                        }
                        const f = e.match(/[¥$€£₹₽₩₪₦₨₫₴₸₺₼₾₿]/);
                        if (f) {
                            const c = f[0];
                            const a = currencyFromSymbol(c);
                            const b = {
                                currency: a,
                                money_format: "{{amount}}",
                            };
                            return b;
                        }
                    }
                }
            }
            const d =
                document.querySelector('meta[property="product:price:currency"]') ||
                document.querySelector('meta[name="currency"]') ||
                document.querySelector('meta[property="og:price:currency"]');
            if (d && d.content) {
                const b = d.content.toUpperCase();
                const a = {
                    currency: b,
                    money_format: "{{amount}}",
                };
                return a;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function isKnownCurrency(c) {
        const a = [
            "USD",
            "EUR",
            "GBP",
            "JPY",
            "CNY",
            "CAD",
            "AUD",
            "CHF",
            "SEK",
            "NOK",
            "DKK",
            "PLN",
            "CZK",
            "HUF",
            "RUB",
            "TRY",
            "BRL",
            "MXN",
            "INR",
            "KRW",
            "SGD",
            "HKD",
            "NZD",
            "ZAR",
            "THB",
            "MYR",
            "PHP",
            "IDR",
            "VND",
            "TWD",
        ];
        return a.includes(c);
    }
    function currencyFromSymbol(c) {
        const a = {
            $: "USD",
            "€": "EUR",
            "£": "GBP",
            "¥": "CNY",
            "₹": "INR",
            "₽": "RUB",
            "₩": "KRW",
            "₪": "ILS",
            "₦": "NGN",
            "₨": "PKR",
            "₫": "VND",
            "₴": "UAH",
            "₸": "KZT",
            "₺": "TRY",
            "₼": "AZN",
            "₾": "GEL",
            "₿": "BTC",
        };
        return a[c] || "USD";
    }
    function getStoreLogoUrl() {
        try {
            const d = [
                ".header__logo img",
                ".site-header__logo img",
                ".logo img",
                ".header-logo img",
                ".site-logo img",
                ".brand-logo img",
                ".header .logo img",
                '.header img[alt*="logo"]',
                '.header img[alt*="Logo"]',
                '.site-header img[alt*="logo"]',
                '.site-header img[alt*="Logo"]',
                'img[class*="logo"]',
                'img[id*="logo"]',
                ".header img:first-child",
                ".site-header img:first-child",
            ];
            for (const c of d) {
                const d = document.querySelector(c);
                if (d && d.src) {
                    let a = d.src;
                    if (a.startsWith("http:")) {
                        a = a.replace("http:", "https:");
                    }
                    if (!a.startsWith("http")) {
                        if (a.startsWith("//")) {
                            a = "https:" + a;
                        } else if (a.startsWith("/")) {
                            a = window.location.origin + a;
                        }
                    }
                    return a;
                }
            }
            const e = document.querySelectorAll('script[type="application/ld+json"]');
            for (const c of e) {
                try {
                    const d = JSON.parse(c.textContent);
                    if (d["@type"] === "Organization" && d.logo) {
                        const b = typeof d.logo === "string" ? d.logo : d.logo.url;
                        if (b) {
                            return b;
                        }
                    }
                } catch (b) { }
            }
            const a =
                document.querySelector('meta[property="og:image"]') ||
                document.querySelector('meta[name="twitter:image"]');
            if (a && a.content) {
                return a.content;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function getParamOrStorage(d, a, b) {
        try {
            const c = utils.getUrlParameter(d);
            if (c) {
                sessionStorage.setItem(a, c);
                //console.log("[像素ID] 从URL获取并保存: " + c);
                return c;
            }
            const e = sessionStorage.getItem(a);
            if (e) {
                //console.log("[像素ID] 从SessionStorage读取: " + e);
                return e;
            }
            if (b) {
                //console.log("[像素ID] 使用默认配置: " + b);
                return b;
            }
            return null;
        } catch (c) {
            //console.error("[像素ID获取错误]", c);
            return b || null;
        }
    }
    function getFacebookPixelId() {
        return getParamOrStorage(
            "custom-facebook-pixel",
            "shopify_facebook_pixel_id",
            FACEBOOK_PIXEL_ID,
        );
    }
    function getFacebookBrowserId() {
        const b = document.cookie.match(/_fbp=([^;]*)/);
        if (b) {
            return b[1];
        } else {
            return null;
        }
    }
    function getTikTokPixelId() {
        return getParamOrStorage(
            "custom-tiktok-pixel",
            "shopify_tiktok_pixel_id",
            TIKTOK_PIXEL_ID,
        );
    }
    function getAdsId() {
        const key = "adsId";
        const adsId = utils.getUrlParameter(key);
        if (adsId) {
            localStorage.setItem(key, adsId);
            return adsId;
        }
        return localStorage.getItem(key) || "";
    }
    // Hosted checkout redirect and backend upload
    async function redirectToHostedCheckout(cartPayload) {
        sessionStorage.setItem("JwrIsShopify", "true");
        if (cartPayload && cartPayload.products.length > 0) {
            try {
                cartPayload.store_domain = window.location.host;
                const storeLogo = getStoreLogoUrl();
                if (storeLogo) {
                    cartPayload.store_logo = storeLogo;
                }
                const storeMoney = await getStoreCurrencyInfo();
                cartPayload.store_currency = storeMoney.currency;
                cartPayload.store_money_format = storeMoney.money_format;
                cartPayload.facebook_pixel_id = getFacebookPixelId();
                cartPayload.fbp = getFacebookBrowserId();
                cartPayload.tiktok_pixel_id = getTikTokPixelId();
                const shopifyConfig = {
                    shop_name: window.location.hostname,
                    access_token: SHOPIFY_ADMIN_TOKEN,
                };
                cartPayload.shopify_config = shopifyConfig;
                //const d = encodeURIComponent(JSON.stringify(cartPayload));
                const orderNo = randomString(24);
                if (
                    /^\d{1,3}(\.\d{1,3}){3}$/.test(cartPayload.store_domain) === false
                ) {
                    cartPayload.store_domain = cartPayload.store_domain.replace(
                        /^www\./,
                        "",
                    );
                }
                const param = {
                    adminToken: SHOPIFY_ADMIN_TOKEN,
                    domainName: cartPayload.store_domain,
                    cartInfo: JSON.stringify(cartPayload),
                    orderNo: orderNo,
                    deviceId: await getDeviceId(),
                    awId: getAdsId(),
                };
                try {
                    const res = await uploadCartInfo(param);
                    if (res.data) {
                        window.location.href = `${checkoutBaseUrl}/${res.data}`;
                    }
                } catch (e) {
                    console.log("上传购物车信息失败:", e);
                }

                // const e = checkoutBaseUrl + "?cart_data=" + d + "&source=" + cartPayload.type;
                // sessionStorage.setItem("shopify_store_domain", cartPayload.store_domain);
                // if (storeLogo) {
                //   sessionStorage.setItem("shopify_store_logo", storeLogo);
                // }
                // sessionStorage.setItem("shopify_store_currency", cartPayload.store_currency);
                // sessionStorage.setItem("shopify_store_money_format", cartPayload.store_money_format);
                // sessionStorage.setItem("shopify_config", JSON.stringify(cartPayload.shopify_config));
                // window.location.href = e;
            } catch (b) {
                //window.location.href = checkoutBaseUrl;
            }
        } else {
            try {
                const d = "https://" + window.location.hostname;
                const storeLogo = getStoreLogoUrl();
                sessionStorage.setItem("shopify_store_domain", d);
                if (storeLogo) {
                    sessionStorage.setItem("shopify_store_logo", storeLogo);
                }
                let b = checkoutBaseUrl + "?store_domain=" + encodeURIComponent(d);
                if (storeLogo) {
                    b += "&store_logo=" + encodeURIComponent(storeLogo);
                }
                window.location.href = b;
            } catch (b) {
                window.location.href = checkoutBaseUrl;
            }
        }
    }
    async function upload() {
        const deviceId = await getDeviceId();
        uploadVisitInfo({
            domainName: location.host,
            deviceId: deviceId,
            adminToken: SHOPIFY_ADMIN_TOKEN,
            awId: getAdsId(),
        });
    }
    async function getDeviceId() {
        let deviceId = localStorage.getItem("deviceId");
        if (deviceId) {
            return deviceId;
        }
        try {
            const FingerprintJS =
                await import("https://openfpcdn.io/fingerprintjs/v5");
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            deviceId = result.visitorId || randomString(32).toLowerCase();
        } catch (e) {
            deviceId = randomString(32).toLowerCase();
        }
        localStorage.setItem("deviceId", deviceId);
        return deviceId;
    }

    async function uploadCartInfo(cartData) {
        const response = await fetch(API + "/api/orderLine/savecartinfo", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cartData),
        });

        if (!response.ok) {
            throw new Error(`HTTP错误: ${response.status}`);
        }
        return await response.json();
    }
    function randomString(length = 24) {
        const chars =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const array = new Uint8Array(length);
        crypto.getRandomValues(array);
        return Array.from(array, (x) => chars[x % chars.length]).join("");
    }
    function bindCheckoutElement(d) {
        if (d.dataset.hijacked || isAddToCartButton(d) || !isCheckoutButton(d)) {
            return;
        }
        d.dataset.hijacked = "true";
        d.addEventListener(
            "click",
            async function (a) {
                await handleCheckoutClick(a, d);
            },
            true,
        );
    }
    function injectPaymentInterceptStyles() {
        if (document.querySelector("#payment-intercept-styles")) {
            return;
        }
        const b = document.createElement("style");
        b.id = "payment-intercept-styles";
        b.textContent =
            '.paypal-overlay { position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; background: transparent !important; z-index: 999 !important; cursor: pointer !important; pointer-events: auto !important; } .paypal-button-container, .paypal-buttons, [data-shopify-buttoncontainer] { position: relative !important; } .custom-checkout-loading { cursor: wait !important; opacity: 0.78 !important; pointer-events: none !important; } .custom-checkout-loading:not(input):not(.custom-checkout-loading-overlay) { display: inline-flex !important; align-items: center !important; justify-content: center !important; gap: 8px !important; } .custom-checkout-loading-spinner { width: 16px !important; height: 16px !important; border: 2px solid currentColor !important; border-right-color: transparent !important; border-radius: 50% !important; display: inline-block !important; animation: customCheckoutSpin 0.75s linear infinite !important; } .custom-checkout-loading-overlay::after { content: "" !important; position: absolute !important; left: 50% !important; top: 50% !important; width: 18px !important; height: 18px !important; margin-left: -9px !important; margin-top: -9px !important; border: 2px solid currentColor !important; border-right-color: transparent !important; border-radius: 50% !important; animation: customCheckoutSpin 0.75s linear infinite !important; z-index: 1000 !important; } @keyframes customCheckoutSpin { to { transform: rotate(360deg); } }';
        document.head.appendChild(b);
    }
    function initializeCheckoutInterception() {
        injectPaymentInterceptStyles();
        document
            .querySelectorAll('button, input[type="submit"], a')
            .forEach(bindCheckoutElement);
        hijackAcceleratedCheckoutButtons();
        setTimeout(hijackAcceleratedCheckoutButtons, 2000);
    }
    const checkoutButtonObserver = new MutationObserver(function (b) {
        b.forEach(function (b) {
            b.addedNodes.forEach(function (c) {
                if (c.nodeType === 1) {
                    if (
                        c.matches &&
                        (c.matches("button") ||
                            c.matches('input[type="submit"]') ||
                            c.matches("a"))
                    ) {
                        bindCheckoutElement(c);
                    }
                    if (c.querySelectorAll) {
                        const a = c.querySelectorAll('button, input[type="submit"], a');
                        a.forEach(bindCheckoutElement);
                    }
                    if (
                        c.matches &&
                        (c.matches('iframe[name*="paypal"]') ||
                            c.matches('iframe[title*="PayPal"]') ||
                            c.matches(".paypal-button-container") ||
                            c.matches(".shopify-payment-button__more-options") ||
                            c.matches("more-payment-options-link"))
                    ) {
                        hijackAcceleratedCheckoutButtons();
                    }
                    if (c.querySelectorAll) {
                        const a = c.querySelectorAll(
                            'iframe[name*="paypal"], iframe[title*="PayPal"], .paypal-button-container, .shopify-payment-button__more-options, more-payment-options-link',
                        );
                        if (a.length > 0) {
                            hijackAcceleratedCheckoutButtons();
                        }
                    }
                }
            });
        });
    });
    document.addEventListener(
        "click",
        async function (d) {
            const a = d.target;
            if (
                a.closest('iframe[name*="paypal"]') ||
                a.closest('iframe[title*="PayPal"]') ||
                a.closest(".paypal-button-container") ||
                a.closest(".paypal-buttons") ||
                a.matches(".shopify-payment-button__more-options") ||
                a.matches("#more-payment-options-link") ||
                a.closest("more-payment-options-link")
            ) {
                if (!a.dataset.hijacked && !a.closest('[data-hijacked="true"]')) {
                    await handleCheckoutClick(d, a);
                } else {
                }
            }
        },
        true,
    );
    async function uploadVisitInfo(visitInfo) {
        const response = await fetch(API + "/api/orderLine/saveVisitInfo", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(visitInfo),
        });

        if (!response.ok) {
            throw new Error(`HTTP错误: ${response.status}`);
        }
        return await response.json();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
            upload();
            initializeCheckoutInterception();
            const b = {
                childList: true,
                subtree: true,
            };
            checkoutButtonObserver.observe(document.body, b);
        });
    } else {
        initializeCheckoutInterception();
        if (document.body) {
            const b = {
                childList: true,
                subtree: true,
            };
            checkoutButtonObserver.observe(document.body, b);
        }
    }
    function handlePaymentSuccessFromUrl() {
        const d = new URLSearchParams(window.location.search);
        const e = d.get("payment_success");
        const a = d.get("from_thank_you");
        if (e) {
            removePaymentSuccessParam();
            try {
                const b = JSON.parse(decodeURIComponent(e));
                if (b.success === "1") {
                    createShopifyOrder(b);
                }
            } catch (b) { }
        } else if (a) {
            handleThankYouReturn();
        }
    }
    function handleThankYouReturn() {
        try {
            const c = sessionStorage.getItem("payment_data");
            if (c) {
                const a = JSON.parse(c);
                if (a.success === "1") {
                    createShopifyOrder(a);
                    sessionStorage.removeItem("payment_data");
                }
            }
        } catch (b) {
            console.error("Check the thank you page for order creation failure:", b);
        }
    }
    function removePaymentSuccessParam() {
        const b = new URL(window.location);
        b.searchParams.delete("payment_success");
        window.history.replaceState({}, document.title, b.toString());
    }
    async function findProductByTitle(f) {
        try {
            const a = await fetch(
                "/search/suggest.json?q=" +
                encodeURIComponent(f) +
                "&resources[type]=product&resources[limit]=1",
            );
            if (!a.ok) {
                return null;
            }
            const b = await a.json();
            if (!b.resources?.results?.products?.[0]) {
                return null;
            }
            const c = await fetch(
                "/products/" + b.resources.results.products[0].handle + ".js",
            );
            const d = c.ok ? await c.json() : null;
            return d?.variants?.[0]?.id || null;
        } catch (b) {
            return null;
        }
    }
    let isCreatingOrder = false;
    async function createShopifyOrder(i) {
        if (isCreatingOrder) {
            return;
        }
        isCreatingOrder = true;
        const a = window.location.hostname;
        if (!i.cart || !i.cart.items) {
            isCreatingOrder = false;
            return;
        }
        let g = i.cart.items || i.cart.products || [];
        if (!Array.isArray(g)) {
            isCreatingOrder = false;
            return;
        }
        for (let c of g) {
            if (!c.id || c.id === "unknown" || isNaN(c.id) || parseInt(c.id) <= 0) {
                const b = await findProductByTitle(c.title);
                if (b) {
                    c.id = b.toString();
                }
            }
        }
        let b = null;
        try {
            const d = {
                "X-Shopify-Access-Token": SHOPIFY_ADMIN_TOKEN,
            };
            const c = {
                headers: d,
            };
            const e = await fetch(
                "https://" +
                a +
                "/admin/api/2023-10/customers/search.json?query=email:" +
                encodeURIComponent(i.customer_email),
                c,
            );
            if (e.ok) {
                const c = await e.json();
                if (c.customers && c.customers.length > 0) {
                    b = c.customers[0].id;
                }
            }
            if (!b) {
                const d = {
                    first_name: i.customer_firstName,
                    last_name: i.customer_lastName,
                    email: i.customer_email,
                    verified_email: true,
                    addresses: [
                        {
                            first_name: i.billing_address.first_name,
                            last_name: i.billing_address.last_name,
                            address1: i.billing_address.address1,
                            address2: i.billing_address.address2,
                            city: i.billing_address.city,
                            province: i.billing_address.province,
                            zip: i.billing_address.zip,
                            country: i.billing_address.country,
                        },
                    ],
                };
                const c = {
                    customer: d,
                };
                const e = c;
                const f = {
                    "Content-Type": "application/json",
                    "X-Shopify-Access-Token": SHOPIFY_ADMIN_TOKEN,
                };
                const g = await fetch(
                    "https://" + a + "/admin/api/2023-10/customers.json",
                    {
                        method: "POST",
                        headers: f,
                        body: JSON.stringify(e),
                    },
                );
                if (g.ok) {
                    const c = await g.json();
                    b = c.customer.id;
                }
            }
        } catch (b) {
            console.error("Error creating/looking up user:", b);
        }
        const c =
            "Payment method: " +
            i.paymentMethod +
            "\nOrder source: " +
            (i.is_direct_purchase ? "Direct Purchase" : "Cart Checkout");
        const e = {
            order: {
                email: i.customer_email,
                financial_status: "paid",
                fulfillment_status: null,
                send_receipt: true,
                send_fulfillment_receipt: true,
                note: c,
                customer: {
                    first_name: i.customer_firstName,
                    last_name: i.customer_lastName,
                    email: i.customer_email,
                },
                customer_id: b || null,
                tags: [
                    "custom-checkout",
                    i.paymentMethod.toLowerCase().replace(" ", "-"),
                ],
                customer_locale: "en",
                currency: i.cart.currency || "USD",
                source_name: "custom-checkout",
                source_identifier: "custom-checkout-plugin",
                billing_address: {
                    first_name: i.billing_address.first_name,
                    last_name: i.billing_address.last_name,
                    address1: i.billing_address.address1,
                    address2: i.billing_address.address2,
                    city: i.billing_address.city,
                    province: i.billing_address.province,
                    zip: i.billing_address.zip,
                    country: i.billing_address.country,
                },
                shipping_address: {
                    first_name: i.shipping_address.first_name,
                    last_name: i.shipping_address.last_name,
                    address1: i.shipping_address.address1,
                    address2: i.shipping_address.address2,
                    city: i.shipping_address.city,
                    province: i.shipping_address.province,
                    zip: i.shipping_address.zip,
                    country: i.shipping_address.country,
                },
                line_items: g.map((d) => {
                    const a = d.id;
                    const b =
                        a &&
                        a !== "unknown" &&
                        a !== null &&
                        a !== undefined &&
                        !isNaN(a) &&
                        parseInt(a) > 0;
                    if (b) {
                        return {
                            variant_id: parseInt(a),
                            quantity: d.quantity,
                        };
                    } else {
                        const a = {
                            title: d.title,
                            price: (d.price / 100).toFixed(2),
                            quantity: d.quantity,
                            requires_shipping: true,
                            taxable: true,
                        };
                        if (d.variant_title && d.variant_title.trim() !== "") {
                            a.variant_title = d.variant_title;
                        }
                        return a;
                    }
                }),
                note_attributes: [
                    {
                        name: "Order Source",
                        value: i.is_direct_purchase ? "Direct Purchase" : "Cart Checkout",
                    },
                    {
                        name: "Payment Method",
                        value: i.paymentMethod,
                    },
                ],
                transactions: [
                    {
                        kind: "sale",
                        status: "success",
                        amount: (i.cart.total_price / 100).toFixed(2),
                        currency: i.cart.currency || "USD",
                        gateway: i.paymentMethod,
                    },
                ],
            },
        };
        try {
            const d = await fetch("https://" + a + "/admin/api/2023-10/orders.json", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Access-Token": SHOPIFY_ADMIN_TOKEN,
                },
                body: JSON.stringify(e),
            });
            if (d.ok) {
                const a = await d.json();
                if (a.order) {
                } else {
                    console.error(
                        "There is no order information in the API response:",
                        a,
                    );
                }
                if (!i.is_direct_purchase) {
                    try {
                        sessionStorage.setItem(
                            "pending_order_success",
                            JSON.stringify(a.order),
                        );
                    } catch (b) {
                        console.error("Failed to store order information:", b);
                    }
                    await clearCart();
                } else if (a.order) {
                    showOrderSuccessMessage(a.order);
                } else {
                    console.error(
                        "Unable to display success message, no order information in the response",
                    );
                }
            } else {
                const c = await d.text();
                console.error("Shopify API call failed:", d.status, d.statusText, c);
                try {
                    const a = JSON.parse(c);
                    console.error("Shopify API error details:", a);
                } catch (b) {
                    console.error("Unable to parse error response as JSON");
                }
            }
        } catch (b) {
            console.error("An error occurred while creating a Shopify order:", b);
            console.error("Error details:", b.message);
        } finally {
            isCreatingOrder = false;
        }
    }
    function showOrderSuccessMessage(f) {
        const a = document.querySelector(".order-success-message");
        if (a) {
            a.remove();
        }
        const b = document.createElement("div");
        b.className = "order-success-message";
        b.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
            color: white;
            padding: 20px 25px;
            border-radius: 12px;
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3);
            z-index: 10000;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            font-size: 14px;
            max-width: 350px;
            min-width: 300px;
            animation: slideInRight 0.4s ease-out;
            border: 1px solid rgba(255, 255, 255, 0.2);
        `;
        if (!document.querySelector("#success-message-styles")) {
            const b = document.createElement("style");
            b.id = "success-message-styles";
            b.textContent = `
                @keyframes slideInRight {
                    from {
                        opacity: 0;
                        transform: translateX(100%);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
                @keyframes slideOutRight {
                    from {
                        opacity: 1;
                        transform: translateX(0);
                    }
                    to {
                        opacity: 0;
                        transform: translateX(100%);
                    }
                }
            `;
            document.head.appendChild(b);
        }
        const c = window.location.hostname;
        const d = "https://" + c + "/account/orders/" + f.id;
        b.innerHTML =
            `
            <div style="position: relative;">
                <!-- 关闭按钮 -->
                <button onclick="this.closest('.order-success-message').remove()" style="
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    background: rgba(255, 255, 255, 0.2);
                    color: white;
                    border: none;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.3s ease;
                " onmouseover="this.style.background='rgba(255, 255, 255, 0.3)'" onmouseout="this.style.background='rgba(255, 255, 255, 0.2)'">×</button>
                
                <div style="display: flex; align-items: center; margin-bottom: 12px;">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style="margin-right: 10px;">
                        <circle cx="12" cy="12" r="12" fill="rgba(255, 255, 255, 0.2)"/>
                        <path d="M10 14L8 12L7.29 12.71L10 15.41L17 8.41L16.29 7.7L10 14Z" fill="white"/>
                    </svg>
                    <div>
                        <div style="font-size: 16px; font-weight: 600; margin-bottom: 2px;">Payment Successful!</div>
                        <div style="font-size: 12px; opacity: 0.9;">Order #` +
            f.order_number +
            " - " +
            f.currency +
            " " +
            f.total_price +
            `</div>
                    </div>
                </div>
                
                <a href="` +
            d +
            `" style="
                    background: rgba(255, 255, 255, 0.2);
                    color: white;
                    text-decoration: none;
                    padding: 8px 16px;
                    border-radius: 6px;
                    font-size: 13px;
                    font-weight: 500;
                    display: inline-block;
                    transition: all 0.3s ease;
                    border: 1px solid rgba(255, 255, 255, 0.3);
                " onmouseover="this.style.background='rgba(255, 255, 255, 0.3)'" onmouseout="this.style.background='rgba(255, 255, 255, 0.2)'">View Order</a>
            </div>
        `;
        document.body.appendChild(b);
        setTimeout(() => {
            if (b.parentNode) {
                b.style.animation = "modalSlideOut 0.5s ease-out";
                setTimeout(() => {
                    if (b.parentNode) {
                        b.parentNode.removeChild(b);
                    }
                }, 500);
            }
        }, 15000);
    }
    async function clearCart() {
        try {
            const b = await fetch("/cart/clear.js", {
                method: "POST",
            });
            if (!b.ok) {
                const c = await fetch("/cart.js");
                if (c.ok) {
                    const d = await c.json();
                    for (const c of d.items) {
                        const a = {
                            id: c.variant_id,
                            quantity: 0,
                        };
                        await fetch("/cart/change.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(a),
                        });
                    }
                }
            }
            refreshCartUi();
            if (window.location.pathname.includes("/cart")) {
                setTimeout(() => {
                    window.location.reload();
                }, 50);
            }
        } catch (b) {
            console.error("Error emptying shopping cart:", b);
        }
    }
    function refreshCartUi() {
        if (window.theme?.cart?.update) {
            window.theme.cart.update();
        }
        document.dispatchEvent(new CustomEvent("cart:updated"));
        updateCartCount(0);
        if (
            window.location.pathname.includes("/cart") ||
            document.querySelector(".cart-page, .cart-drawer, [data-cart-items]")
        ) {
            document
                .querySelectorAll(".cart-items, [data-cart-items], .cart-drawer__items")
                .forEach((b) => {
                    if (b) {
                        b.innerHTML =
                            '<p style="text-align: center; color: #666; padding: 20px;">Your cart is empty</p>';
                    }
                });
            document
                .querySelectorAll(".cart-total, [data-cart-total], .cart-drawer__total")
                .forEach((b) => {
                    if (b) {
                        b.textContent = "$0.00";
                    }
                });
            document
                .querySelectorAll(".cart__checkout-button, [data-cart-checkout]")
                .forEach((b) => {
                    if (b) {
                        b.style.display = "none";
                    }
                });
        }
        setTimeout(() => {
            if (window.location.pathname.includes("/cart")) {
                window.location.reload();
            }
        }, 50);
    }
    function updateCartCount(c) {
        document
            .querySelectorAll(
                ".cart-count, [data-cart-count], .cart-item-count, .header__cart-count",
            )
            .forEach((a) => {
                if (a) {
                    a.textContent = c;
                    if (c === 0) {
                        a.style.display = "none";
                    }
                }
            });
    }
    function showPendingOrderSuccess() {
        try {
            const c = sessionStorage.getItem("pending_order_success");
            if (c) {
                const a = JSON.parse(c);
                showOrderSuccessMessage(a);
                sessionStorage.removeItem("pending_order_success");
            }
        } catch (b) {
            console.error("Error checking for success message to display:", b);
        }
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
            handlePaymentSuccessFromUrl();
            showPendingOrderSuccess();
        });
    } else {
        handlePaymentSuccessFromUrl();
        showPendingOrderSuccess();
    }
    function getCurrentProductInfo() {
        try {
            if (
                window.ShopifyAnalytics &&
                window.ShopifyAnalytics.meta &&
                window.ShopifyAnalytics.meta.product
            ) {
                const c = window.ShopifyAnalytics.meta.product;
                const a = {
                    id: c.id,
                    title: c.title || "",
                    price: c.price || "0",
                    variant_id: c.variants && c.variants[0] ? c.variants[0].id : null,
                };
                return a;
            }
            const c = utils.findElement(CONFIG.TITLE_SELECTORS, document);
            const a = utils.findElement(CONFIG.PRICE_SELECTORS, document);
            const b = utils.findElement(CONFIG.VARIANT_SELECTORS, document);
            if (c || a) {
                return {
                    id: b ? b.value : null,
                    title: c ? c.textContent.trim() : "",
                    price: a ? utils.cleanPrice(a.textContent) : "0",
                    variant_id: b ? b.value : null,
                };
            }
            return null;
        } catch (b) {
            console.error("Error getting current product info:", b);
            return null;
        }
    }
    function trackFacebookAddToCart() {
        if (!getFacebookPixelId()) {
            return false;
        }
        if (typeof window.fbq !== "undefined") {
            const b = getCurrentProductInfo();
            if (b) {
                window.fbq("track", "AddToCart", {
                    content_ids: [b.id],
                    content_type: "product",
                    content_name: b.title,
                    value: parseFloat(b.price) || 0,
                    currency: "USD",
                });
            }
        }
        return false;
    }
    function trackFacebookViewContent() {
        if (!getFacebookPixelId()) {
            return false;
        }
        if (typeof window.fbq !== "undefined") {
            const b = getCurrentProductInfo();
            if (b) {
                window.fbq("track", "ViewContent", {
                    content_ids: [b.id],
                    content_type: "product",
                    content_name: b.title,
                    value: parseFloat(b.price) || 0,
                    currency: "USD",
                });
            }
        }
        return false;
    }
    function initTikTokPixel() {
        const g = getTikTokPixelId();
        if (!g) {
            return false;
        }
        if (typeof window.ttq !== "undefined") {
            return true;
        }
        (function (a, b, h) {
            a.TiktokAnalyticsObject = h;
            var d = (a[h] = a[h] || []);
            d.methods = [
                "page",
                "track",
                "identify",
                "instances",
                "debug",
                "on",
                "off",
                "once",
                "ready",
                "alias",
                "group",
                "enableCookie",
                "disableCookie",
            ];
            d.setAndDefer = function (c, a) {
                c[a] = function () {
                    c.push([a].concat(Array.prototype.slice.call(arguments, 0)));
                };
            };
            for (var c = 0; c < d.methods.length; c++) {
                d.setAndDefer(d, d.methods[c]);
            }
            d.instance = function (e) {
                for (var a = d._i[e] || [], b = 0; b < d.methods.length; b++) {
                    d.setAndDefer(a, d.methods[b]);
                }
                return a;
            };
            d.load = function (e, a) {
                var b = "https://analytics.tiktok.com/i18n/pixel/events.js";
                d._i = d._i || {};
                d._i[e] = [];
                d._i[e]._u = b;
                d._t = d._t || {};
                d._t[e] = +new Date();
                d._o = d._o || {};
                d._o[e] = a || {};
                var c = document.createElement("script");
                c.type = "text/javascript";
                c.async = true;
                c.src = b + "?sdkid=" + e + "&lib=" + h;
                var f = document.getElementsByTagName("script")[0];
                f.parentNode.insertBefore(c, f);
            };
            d.load(g);
            d.page();
        })(window, document, "ttq");
        return true;
    }
    function trackTikTokAddToCart() {
        if (!getTikTokPixelId()) {
            return false;
        }
        if (typeof window.ttq !== "undefined") {
            const b = getCurrentProductInfo();
            if (b) {
                window.ttq.track("AddToCart", {
                    content_id: b.id,
                    content_type: "product",
                    content_name: b.title,
                    value: parseFloat(b.price) || 0,
                    currency: "USD",
                });
            }
        }
        return false;
    }
    function initFacebookPixel() {
        const b = getFacebookPixelId();
        if (!b) {
            return false;
        }
        if (typeof window.fbq !== "undefined") {
            return true;
        }
        (function (h, a, b, c, d, i, j) {
            if (h.fbq) {
                return;
            }
            d = h.fbq = function () {
                if (d.callMethod) {
                    d.callMethod.apply(d, arguments);
                } else {
                    d.queue.push(arguments);
                }
            };
            if (!h._fbq) {
                h._fbq = d;
            }
            d.push = d;
            d.loaded = true;
            d.version = "2.0";
            d.queue = [];
            i = a.createElement(b);
            i.async = true;
            i.src = c;
            j = a.getElementsByTagName(b)[0];
            j.parentNode.insertBefore(i, j);
        })(
            window,
            document,
            "script",
            "https://connect.facebook.net/en_US/fbevents.js",
        );
        window.fbq("init", b);
        window.fbq("track", "PageView");
        return true;
    }
    function interceptCartRequestsForPixels() {
        const d = window.fetch;
        window.fetch = function (...a) {
            const b = a[0];
            if (
                typeof b === "string" &&
                (b.includes("/cart/add") ||
                    b.includes("/cart/add.js") ||
                    b.includes("/cart/change"))
            ) {
                return d.apply(this, a).then((c) => {
                    if (c.ok && b.includes("/cart/add")) {
                        trackFacebookAddToCart();
                        trackTikTokAddToCart();
                    }
                    return c;
                });
            }
            return d.apply(this, a);
        };
        const e = XMLHttpRequest.prototype.open;
        const a = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.open = function (b, a) {
            this._url = a;
            return e.apply(this, arguments);
        };
        XMLHttpRequest.prototype.send = function () {
            if (this._url && this._url.includes("/cart/add")) {
                this.addEventListener("load", function () {
                    if (this.status === 200) {
                        trackFacebookAddToCart();
                        trackTikTokAddToCart();
                    }
                });
            }
            return a.apply(this, arguments);
        };
    }
    function isProductPage() {
        const b = window.location.pathname;
        if (b.includes("/products/")) {
            return true;
        }
        if (
            window.meta?.page?.pageType === "product" ||
            window.ShopifyAnalytics?.meta?.page?.pageType === "product"
        ) {
            return true;
        }
        if (document.querySelector('form[action*="/cart/add"]')) {
            return true;
        }
        return false;
    }
    function trackProductViewLater() {
        if (!getFacebookPixelId()) {
            return;
        }
        if (!isProductPage()) {
            return;
        }
        setTimeout(() => {
            trackFacebookViewContent();
        }, 1000);
    }
    function initializePixels() {
        const c = getFacebookPixelId();
        const a = getTikTokPixelId();
        if (!c && !a) {
            return;
        }
        if (c) {
            initFacebookPixel();
            trackProductViewLater();
        }
        if (a) {
            initTikTokPixel();
        }
        interceptCartRequestsForPixels();
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initializePixels);
    } else {
        initializePixels();
    }
})();
